import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import { decodeUri, storage, getCookie, inBrowser, parseReferrer } from 'analytics-utils';

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}
/**
 * Turn object into pipe separated values
 * @param  {Object} [obj={}] - Object to transform
 * @return {String} - pipe separated value
 *
 * @Example
 *
 *  formatCookie({})
 *  // utmcsr=SOURCE|utmcmd=MEDIUM[|utmccn=CAMPAIGN][|utmcct=CONTENT][|utmctr=TERM/KEYWORD]
 *
 */


function formatPipeString(obj) {
  if (!obj || _typeof(obj) !== 'object') {
    return null;
  }

  return Object.keys(obj).reduce(function (acc, curr, i) {
    return "".concat(acc).concat(i ? '|' : '').concat(curr, "=").concat(obj[curr]);
  }, '');
}
/**
 * Parse utmz cookie
 * @param  {String} cookie - utmz cookie value
 * @return {Object} - parsed object of cookie
 *
 * @Example
 *
 * parsePipeString('438.1531.1.1.utmcsr=(direct)|utmccn=(direct)|utmcmd=(none)')
 *
 * parsePipeString('16602.15.1.1.utmcsr=google|utmccn=(organic)|utmcmd=organic|utmctr=(not%20provided)')
 */


function parsePipeString(cookie) {
  var keyMap = {
    'utmcsr': 'source',
    'utmcmd': 'medium',
    'utmccn': 'campaign',
    'utmcct': 'content',
    'utmctr': 'term',
    'utmgclid': 'gclid',
    // Google Click ID from autotagged PPC
    'utmdclid': 'dclid' // Display Click Identifier.

  };
  var keyValues = cookie ? cookie.split('|') : [];
  return keyValues.reduce(function (acc, curr, i) {
    var val = keyValues[i].split('=');
    var key = val[0].split('.').pop();

    if (keyMap[key]) {
      acc["".concat(keyMap[key])] = decodeUri(val[1]);
    } else if (typeof curr[key] === 'undefined') {
      acc[key] = decodeUri(val[1]);
    }

    return acc;
  }, {});
}

var events = {
  SET_ORIGINAL_SOURCE: 'setOriginalSource'
};
var CONFIG = {
  storage: 'localStorage',
  originalSourceKey: '__user_original_source',
  originalLandingPageKey: '__user_original_landing_page'
  /**
   * Track original source of visitors.
   * @param  {Object} [pluginConfig] - settings for referral source tracking
   * @param  {String} [pluginConfig.storage] - overide the location of storage. 'localStorage', 'cookie', or 'window'
   * @param  {String} [pluginConfig.originalSourceKey] - overide the storage key. Default '__user_original_source'
   * @param  {String} [pluginConfig.originalLandingPageKey] - overide the storage key. Default '__user_original_landing_page'
   * @return {Object} - plugin for `analytics` package
   */

};

function originalSourcePlugin() {
  var pluginConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    name: 'original-source',
    EVENTS: events,
    config: _objectSpread({}, CONFIG, pluginConfig),
    // Run function on `analyticsInit` event
    bootstrap: function bootstrap(_ref) {
      var instance = _ref.instance,
          config = _ref.config;
      instance.dispatch({
        type: events.SET_ORIGINAL_SOURCE,
        originalSource: getOriginalSource(config),
        originalLandingPage: getOriginalLandingPage(config)
      });
    },
    reset: function reset(_ref2) {
      var instance = _ref2.instance;
      instance.storage.removeItem(CONFIG.originalSourceKey);
      instance.storage.removeItem(CONFIG.originalLandingPageKey);
    }
  };
}

function getOriginalSource() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var config = Object.assign({}, CONFIG, opts);
  var referrer = config.referrer,
      originalSourceKey = config.originalSourceKey; // 1. try first source browser storage

  var originalSrc = storage.getItem(originalSourceKey, {
    storage: config.storage
  });

  if (originalSrc) {
    return parsePipeString(originalSrc);
  } // 2. then try __utmz cookie


  var utmzCookie = getCookie('__utmz');

  if (utmzCookie) {
    var parsedCookie = parsePipeString(utmzCookie);

    if (parsedCookie) {
      setOriginalSource(parsedCookie, config);
      return parsedCookie;
    }
  } // 3. Then try referrer url and utm params


  var ref = inBrowser ? referrer || document.referrer : '';
  var refData = parseReferrer(ref);
  setOriginalSource(refData, config);
  return refData;
}

function setOriginalSource(data, config) {
  storage.setItem(config.originalSourceKey, formatPipeString(data), {
    storage: config.storage
  });
}
/**
 * Get the original landing page of a visitor
 * @param  {Object} opts - plugin
 * @parama {String} opts.originalLandingPageKey - Storage key
 * @parama {String} opts.storage - Storage type
 * @return {String} original landing page uri
 */


function getOriginalLandingPage() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var config = Object.assign({}, CONFIG, opts);
  var key = config.originalLandingPageKey;
  var storageConfig = {
    storage: config.storage // 1. try first source browser storage

  };
  var originalLandingPage = storage.getItem(key, storageConfig);

  if (originalLandingPage) {
    return originalLandingPage;
  }

  var url = inBrowser ? window.location.href : '';
  storage.setItem(key, url, storageConfig);
  return url;
}

export default originalSourcePlugin;
export { getOriginalSource, getOriginalLandingPage };